import api from './api';

export const dashboardService = {
  // Get overdue tasks for dashboard widget
  getOverdueTasks: (viewType = 'my') => api.get(`/dashboard/overdue-tasks?view_type=${viewType}`),

  // Get court deadlines for dashboard widget
  getCourtDeadlines: (viewType = 'my') => api.get(`/dashboard/court-deadlines?view_type=${viewType}`),

  // Get case progress for dashboard widget
  getCaseProgress: (viewType = 'my', search = '') => {
    const params = new URLSearchParams({ view_type: viewType });
    if (search) params.append('search', search);
    return api.get(`/dashboard/case-progress?${params.toString()}`);
  },

  // Get workload data for dashboard widget
  getWorkload: (viewType = 'my') => api.get(`/dashboard/workload?view_type=${viewType}`),

  // Get key metrics for dashboard cards
  getMetrics: (viewType = 'my') => api.get(`/dashboard/metrics?view_type=${viewType}`),

  // Get recent activities for dashboard widget
  getRecentActivities: (limit = 10) => api.get(`/dashboard/recent-activities?limit=${limit}`),

  // Get project completion projections
  getProjections: (viewType = 'my') => api.get(`/dashboard/projections?view_type=${viewType}`),

  // Get detailed list of projects for projections
  getProjectionsDetails: (viewType = 'my', period = 'quarter') =>
    api.get(`/dashboard/projections/details?view_type=${viewType}&period=${period}`),

  // Get per-case trust-capped collectible amounts for projections
  getProjectionsTrust: (viewType = 'my', period = 'quarter') =>
    api.get(`/dashboard/projections/trust?view_type=${viewType}&period=${period}`),

  // Trust Dashboard endpoints
  getTrustTrends: (period = 'weekly') => api.get(`/dashboard/trust/trends?period=${period}`),
  getAccountsNeedingAttention: (limit = 10) => api.get(`/dashboard/trust/attention?limit=${limit}`),
  getRecentTrustActivity: (limit = 10) => api.get(`/dashboard/trust/activity?limit=${limit}`),
  getCaseAllocationSummary: (limit = 10) => api.get(`/dashboard/trust/allocations?limit=${limit}`),

  // Billing analytics endpoints
  getARaging: (viewType = 'my') => api.get(`/dashboard/ar-aging?view_type=${viewType}`),
  getRevenueSummary: (viewType = 'my') => api.get(`/dashboard/revenue?view_type=${viewType}`),
  getUnbilledWork: (viewType = 'my') => api.get(`/dashboard/unbilled?view_type=${viewType}`),

  // Firm-view analytics
  getCaseVolumeByAttorney: () => api.get('/dashboard/case-volume-by-attorney'),

  // Dashboard widget preferences (uses generic user preferences endpoint)
  getWidgetPreferences: () => api.get('/users/preferences/dashboard').catch(() => ({ data: { preference_data: null } })),
  saveWidgetPreferences: (preferences) => api.put('/users/preferences/dashboard', { preference_data: preferences })
};

export default dashboardService;
